import { createSelector } from 'reselect';
import { statComparisonSelector } from './simple-selectors';

export const statComparisonDataTypeSelector = createSelector(
    statComparisonSelector,
    (statComparison) => statComparison.dataType
);
